import { useState } from "react";
import Countdown from "./Countdown";
import QRClaimModal from "./QRClaimModal";
import { Flame, Tag, Store } from "lucide-react";
import { Link } from "react-router-dom";

const accents = ["card-green", "card-magenta", "card-cyan", "card-sunset", "card-purple"];
const stickerVar = ["sticker-green", "sticker-magenta", "sticker-cyan", "sticker-sunset", "sticker-lemon"];

export default function DealCard({ d, idx = 0 }) {
  const [showQR, setShowQR] = useState(false);
  const accent = accents[idx % accents.length];
  const sticker = stickerVar[idx % stickerVar.length];
  const expiringSoon = (new Date(d.expires_at).getTime() - Date.now()) < 12 * 3600 * 1000;
  return (
    <>
    <div data-testid={`deal-card-${d.id}`} className={`card-x ${accent} p-6 flex flex-col bg-[#FAF6E8] tilt`}>
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex flex-col items-start gap-1.5">
          {d.is_flash ? (
            <span className={`sticker ${sticker}`} style={{ transform: "rotate(-3deg)" }}>
              <Flame size={11} strokeWidth={2.6} /> Flash
            </span>
          ) : (
            <span className={`sticker ${sticker}`} style={{ transform: "rotate(-2deg)" }}>
              <Tag size={11} strokeWidth={2.6} /> Deal
            </span>
          )}
          <span className="font-mono-x text-xs font-bold uppercase tracking-widest text-[#0B0F0C]/60">
            -{d.discount_pct}% OFF
          </span>
        </div>
        <div className="text-right">
          <div className="label-overline text-[#0B0F0C]/50 mb-1">Ends in</div>
          <Countdown to={d.expires_at} className={`text-base font-bold ${expiringSoon ? "text-[#FF1A8C]" : ""}`} />
        </div>
      </div>
      <h3 className="font-display text-2xl font-extrabold leading-[1.05] mb-3 tracking-tight">{d.title}</h3>
      {d.description && (
        <p className="text-sm text-[#0B0F0C]/65 mb-5 leading-relaxed">{d.description}</p>
      )}
      <div className="flex items-end gap-3">
        <div>
          <div className="label-overline text-[#0B0F0C]/50">Was</div>
          <div className="font-mono-x text-sm text-[#0B0F0C]/40 line-through">${d.original_price.toFixed(0)}</div>
        </div>
        <div>
          <div className="label-overline text-[#0B0F0C]/50">Now</div>
          <div className="font-display text-3xl font-extrabold tracking-tight">${d.deal_price.toFixed(0)}</div>
        </div>
        {d.code && (
          <div className="ml-auto">
            <div className="label-overline text-[#0B0F0C]/50">Code</div>
            <div className="font-mono-x text-xs px-2 py-1 rounded-full border-2 border-[#0B0F0C] bg-[#FFE74C] font-bold">{d.code}</div>
          </div>
        )}
      </div>
      <div className="my-5 h-0.5 bg-[#0B0F0C]/15 rounded-full" />
      <div className="flex items-center justify-between gap-3">
        <Link
          to={`/dispensary/${d.dispensary_id}`}
          className="flex items-center gap-1.5 text-xs text-[#0B0F0C]/70 hover:text-[#0B0F0C] font-bold"
        >
          <Store size={12} strokeWidth={2.4} />
          {d.dispensary?.name}
        </Link>
        <button
          onClick={() => setShowQR(true)}
          data-testid={`deal-claim-${d.id}`}
          className="btn-x btn-primary !py-2 !px-4 !text-xs"
        >
          Claim →
        </button>
      </div>
    </div>
    {showQR && <QRClaimModal deal={d} onClose={() => setShowQR(false)} />}
    </>
  );
}
